export enum Position {
  Keeper = "K",
  Defender = "V",
  Midfielder = "M",
  Attacker = "A"
}